import * as React from "react";
import Dialog from "../Dialog";

interface Props {
    title: string;
    text: string;
    onCloseDialog: () => any;
}

interface State {
}

const s = require("./TextDialog.scss");

class TextDialog extends React.Component<Props, State> {
    getText() {
        return {__html: this.props.text};
    }

    render(): JSX.Element {
        return (
            <Dialog
                onCloseDialog={this.props.onCloseDialog}
            >
                <div className={s.dialog}>
                    <h2 className={s.title}>{this.props.title}</h2>
                    <div 
                        className={s.content}
                        dangerouslySetInnerHTML={this.getText()}
                    >
                    </div>
                </div>
            </Dialog>
        );
    }
}

export default TextDialog;



// WEBPACK FOOTER //
// ./src/components/Dialogs/TextDialog/index.tsx